import React from 'react';
import PropTypes from 'prop-types';
import { FormattedMessage } from 'react-intl';
import Button from 'components/common/Button';

const propTypes = {
  isContentLoading: PropTypes.bool,
  isLoanSubmitting: PropTypes.bool,
  legalDocument: PropTypes.object,
};

const SubmitButton = (props) => {
  const disabled = props.isContentLoading || props.isLoanSubmitting || !props.legalDocument;
  const customerName = props.legalDocument && props.legalDocument.customerName;

  return (
    <>
      {customerName && (
        <FormattedMessage
          id="offer.submit.sign.customerName"
          tagName="p"
          values={{ customerName }}
        />
      )}
      <Button
        isLoading={disabled}
        disabled={disabled}
        className="btn--wide"
        id-="submit-sign-button"
      >
        <FormattedMessage id="offer.submit.sign" />
      </Button>
    </>
  );
};

SubmitButton.propTypes = propTypes;

export default SubmitButton;
